module.exports = __webpack_public_path__ + "static/media/39.1ef71dbc.svg";